import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronUp = () => {
  return (
    <g>
      <path d="M13.709 11.77a.75.75 0 0 0 1.151-.956l-.07-.085L8.54 4.23a.75.75 0 0 0-.995-.076l-.085.076-6.248 6.499a.751.751 0 0 0 .999 1.115l.082-.074L8 5.834l5.709 5.936z" />
    </g>
  );
};

export default withIcon(IconChevronUp);
